import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { log } from "@/lib/log";

const fail = (fallback) => (e) => toast.error(e?.response?.data?.detail || fallback);

// Letterhead / signature previews, upload and removal for the bid letter.
export function useStationery({ L, user, activeWorkspaceId, reload }) {
  const [imgV, setImgV] = useState(Date.now());
  const [previews, setPreviews] = useState({});
  const hasLetterhead = !!L?.stationery?.letterhead;
  const hasSignature = !!L?.stationery?.signature;

  const fetchPreview = useCallback(async (key, url) => {
    try { const r = await api.get(url, { responseType: "blob" }); setPreviews((p) => ({ ...p, [key]: URL.createObjectURL(r.data) })); }
    catch (e) { log.warn(`${key} preview unavailable:`, e?.response?.status); setPreviews((p) => ({ ...p, [key]: null })); }
  }, []);
  useEffect(() => {
    if (!L) return;
    if (hasLetterhead) fetchPreview("letterhead", `/workspaces/${activeWorkspaceId}/letterhead?v=${imgV}`); else setPreviews((p) => ({ ...p, letterhead: null }));
  }, [L, hasLetterhead, imgV, activeWorkspaceId, fetchPreview]);
  useEffect(() => {
    if (!L) return;
    if (hasSignature) fetchPreview("signature", `/users/${user?.id}/signature?v=${imgV}`); else setPreviews((p) => ({ ...p, signature: null }));
  }, [L, hasSignature, imgV, user?.id, fetchPreview]);

  const imgUrl = (kind) => (kind === "letterhead" ? `/workspaces/${activeWorkspaceId}/letterhead` : "/me/signature");
  const upload = async (kind, file) => {
    if (!file) return;
    const fd = new FormData(); fd.append("file", file);
    try { await api.post(imgUrl(kind), fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success(`${kind === "letterhead" ? "Letterhead" : "Signature"} uploaded`); setImgV(Date.now()); await reload(); } catch (e) { fail("Upload failed")(e); }
  };
  const removeImg = async (kind) => { try { await api.delete(imgUrl(kind)); toast.success("Removed"); setImgV(Date.now()); await reload(); } catch (e) { fail("Remove failed")(e); } };
  return { previews, upload, removeImg };
}
